import angular from 'angular';
import { findIndex } from 'lodash';


const module = angular.module('whyline.directives.extraDateAppointment', []);

const extraDateAppointment = ($parse) => {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      // @Input()
      // selectedArea
      // filteredSlot
      let timeSlotsQuantity$;
      let slotToday$ = [];
      const enabledExtraAppointment = $parse(attrs.enabledExtraAppointment)();
      if (enabledExtraAppointment) {
        const loading = {
          loadingSelectedArea: true,
          loadingFilteredSlot: true
        }

        attrs.$observe('selectedArea', (area) => {
          const selectedArea = $parse(area)();
          timeSlotsQuantity$ = selectedArea.appointmentsConfiguration.timeSlotsQuantity;
          loading.loadingSelectedArea = false;
          calculate();
        });

        attrs.$observe('slotToday', async (allSlot) => {
          slotToday$ = $parse(allSlot)();
          loading.loadingFilteredSlot = false;
          calculate();
        });

        const calculate = () => {
          if (
            !loading.loadingSelectedArea &&
            !loading.loadingFilteredSlot
          ) {
            const isEdit = $parse(attrs.isEdit)();
            const appointmentDateSelected = attrs.appointmentDateSelected;
            const init = findIndex(slotToday$, (slot) => slot.hour === scope.slot.hour);
            const end = init + timeSlotsQuantity$;
            const lookAhead = slotToday$.slice(init, end);
            const lookAheadFilter = lookAhead.filter(nextSlot => nextSlot.reserved >= nextSlot.slots);

            scope.slot.extraAppointment = lookAheadFilter.length > 0;
            scope.slot.isEdit = isEdit;
            scope.slot.appointmentDateSelected = appointmentDateSelected;
          }
        }
      }

    }
  };
};

module.exports = module.directive('extraDateAppointment', extraDateAppointment);